import React from 'react';

function ClinicSettingsSectionHeader({ title, icon, subtitle, actions }) {
    return (
        <div className="clinic-settings-section">
            <div className="clinic-settings-section__meta">
                <h5 className="clinic-settings-section__title">
                    {icon && <i className={`bi ${icon} me-2`}></i>}
                    {title}
                </h5>
                {subtitle && <p className="clinic-settings-section__subtitle">{subtitle}</p>}
            </div>
            {actions && <div className="clinic-settings-section__actions">{actions}</div>}
        </div>
    );
}

export default ClinicSettingsSectionHeader;
